import React from 'react'
import Header from '../common/Header'

function AdminCRM() {
  return (
    <div className='flex-1 overflow-auto relative z-10'>
        <Header title='Customer - Relation - Management' />
        <main className='max-w-7xl mx-auto py-6 px-4 lg:px-8'>
             
        </main>
    </div>
  )
}

export default AdminCRM